import { useEffect, useState } from "react";

const LETTERS = ["V", "I", "S", "M", "A", "R", "K", "S"];
const WORDS = [
  { letters: [0], word: "Visibility" },
  { letters: [1], word: "Intelligence" },
  { letters: [2], word: "Systems" },
  { letters: [3, 4, 5, 6, 7], word: "Markets" },
];

export default function AcronymReveal() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActive((a) => (a + 1) % WORDS.length), 1600);
    return () => clearInterval(t);
  }, []);

  const activeLetters = WORDS[active].letters;

  return (
    <div className="mt-8 inline-flex flex-col gap-2" data-testid="acronym-reveal" aria-label="VISMARKS stands for Visibility Intelligence Systems Markets">
      <div className="flex items-center gap-[3px] font-black tracking-tight text-lg select-none" aria-hidden="true">
        {LETTERS.map((l, i) => (
          <span
            key={i}
            className={
              activeLetters.includes(i)
                ? "text-[#FF3B30] drop-shadow-[0_0_10px_rgba(255,59,48,0.7)]"
                : "text-white/85"
            }
            style={{
              transitionProperty: "color, filter",
              transitionDuration: "450ms",
              transitionDelay: activeLetters.includes(i) ? `${activeLetters.indexOf(i) * 90}ms` : "0ms",
            }}
          >
            {l}
          </span>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2 text-[10px] uppercase tracking-[0.25em]" aria-hidden="true">
        {WORDS.map((w, i) => (
          <span key={w.word} className="flex items-center gap-2">
            {i > 0 && <span className="text-neutral-700">·</span>}
            <span className={i === active ? "font-bold" : ""}>
              {w.word.split("").map((ch, ci) => (
                <span
                  key={ci}
                  className={
                    i === active
                      ? "text-[#FF3B30] drop-shadow-[0_0_8px_rgba(255,59,48,0.6)]"
                      : "text-neutral-600"
                  }
                  style={{
                    transitionProperty: "color, filter",
                    transitionDuration: "400ms",
                    transitionDelay: i === active ? `${ci * 55}ms` : "0ms",
                  }}
                >
                  {ch}
                </span>
              ))}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
